
    export interface IProfitCenter {
        displayName: string;
        code: string;
    }

    export class ProfitCenter implements IProfitCenter {
        displayName: string;
        code: string;
    }
